module.exports = __webpack_public_path__ + "img/background_img_one.b8bd12ef.png";